/**
 * Hook for fetching locations for a project.
 */

import { gql, useQuery } from "@apollo/client";

export interface LocationNode {
  id: string;
  name: string;
  locationType: string;
  parentLocationId: string | null;
  plotId: string | null;
  projectId: string;
  area: number | null;
  hierarchyPath: string[];
}

interface LocationConnection {
  items: LocationNode[];
  totalCount: number;
  hasNextPage: boolean;
}

interface LocationsQueryResult {
  locations: LocationConnection;
}

const GET_LOCATIONS = gql`
  query GetLocations(
    $filter: LocationFilterInput
    $limit: Int
    $offset: Int
  ) {
    locations(filter: $filter, limit: $limit, offset: $offset) {
      items {
        id
        name
        locationType
        parentLocationId
        plotId
        projectId
        area
        hierarchyPath
      }
      totalCount
      hasNextPage
    }
  }
`;

export function useLocations(projectId: string | null) {
  const { data, loading, error } = useQuery<LocationsQueryResult>(
    GET_LOCATIONS,
    {
      variables: {
        filter: projectId ? { projectId } : undefined,
        limit: 500,
        offset: 0,
      },
      skip: !projectId,
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    locations: (data?.locations.items || []) as LocationNode[],
    totalCount: data?.locations.totalCount || 0,
    loading,
    error,
  };
}
